// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes realesy-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes realesy-loader-wave {
  0%,
  100% {
    transform: scaleY(0.35);
  }
  50% {
    transform: scaleY(1);
  }
}

@keyframes realesy-loader-cube {
  0%,
  100% {
    transform: rotateX(-18deg) rotateY(-28deg);
  }
  50% {
    transform: rotateX(18deg) rotateY(28deg);
  }
}

.realesy-ring {
  width: 86px;
  height: 86px;
  border: 7px solid #e5eeff;
  border-top-color: #ff9200;
  border-right-color: #2864e8;
  border-radius: 50%;
  display: grid;
  place-items: center;
  animation: realesy-loader-spin 1.7s linear infinite;
}

.realesy-ring-logo {
  width: 34px;
  height: 34px;
  animation: realesy-loader-spin 1.7s linear infinite reverse;
}

.realesy-wave {
  display: flex;
  gap: 5px;
  align-items: center;
  height: 70px;
}

.realesy-wave i {
  display: block;
  width: 7px;
  height: 40px;
  border-radius: 9px;
  background: linear-gradient(#ff9200, #2864e8);
  animation: realesy-loader-wave 0.9s ease-in-out infinite;
}

.realesy-wave i:nth-child(odd) {
  background: linear-gradient(#2864e8, #9bbcff);
}

.realesy-wave i:nth-child(2n) {
  animation-delay: 0.15s;
}

.realesy-wave i:nth-child(3n) {
  animation-delay: 0.3s;
}

.realesy-wave i:nth-child(4n) {
  animation-delay: 0.45s;
}

.realesy-cube {
  width: 55px;
  height: 55px;
  position: relative;
  transform-style: preserve-3d;
  animation: realesy-loader-cube 2.6s ease-in-out infinite;
  perspective: 300px;
}

.realesy-cube i {
  position: absolute;
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid white;
}

.realesy-cube i:nth-child(1) {
  background: linear-gradient(135deg, #ffc064, #ff9200);
  transform: rotate(45deg) rotateX(60deg) translateZ(22px);
}

.realesy-cube i:nth-child(2) {
  background: linear-gradient(135deg, #78a5ff, #2864e8);
  transform: translateZ(22px);
}

.realesy-cube i:nth-child(3) {
  background: #c8dcff;
  transform: translateX(22px) rotateY(45deg);
}

.realesy-four-dots {
  width: 104px;
  height: 101px;
  display: block;
  background: transparent;
}

@media (prefers-reduced-motion: reduce) {
  .realesy-ring,
  .realesy-ring-logo,
  .realesy-wave i,
  .realesy-cube {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RealesyAnimatedLoaders.css"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;AAC1D;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE;;;;IAIE,qCAAqC;IACrC,uCAAuC;EACzC;AACF","sourcesContent":["@keyframes realesy-loader-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes realesy-loader-wave {\n  0%,\n  100% {\n    transform: scaleY(0.35);\n  }\n  50% {\n    transform: scaleY(1);\n  }\n}\n\n@keyframes realesy-loader-cube {\n  0%,\n  100% {\n    transform: rotateX(-18deg) rotateY(-28deg);\n  }\n  50% {\n    transform: rotateX(18deg) rotateY(28deg);\n  }\n}\n\n.realesy-ring {\n  width: 86px;\n  height: 86px;\n  border: 7px solid #e5eeff;\n  border-top-color: #ff9200;\n  border-right-color: #2864e8;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  animation: realesy-loader-spin 1.7s linear infinite;\n}\n\n.realesy-ring-logo {\n  width: 34px;\n  height: 34px;\n  animation: realesy-loader-spin 1.7s linear infinite reverse;\n}\n\n.realesy-wave {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  height: 70px;\n}\n\n.realesy-wave i {\n  display: block;\n  width: 7px;\n  height: 40px;\n  border-radius: 9px;\n  background: linear-gradient(#ff9200, #2864e8);\n  animation: realesy-loader-wave 0.9s ease-in-out infinite;\n}\n\n.realesy-wave i:nth-child(odd) {\n  background: linear-gradient(#2864e8, #9bbcff);\n}\n\n.realesy-wave i:nth-child(2n) {\n  animation-delay: 0.15s;\n}\n\n.realesy-wave i:nth-child(3n) {\n  animation-delay: 0.3s;\n}\n\n.realesy-wave i:nth-child(4n) {\n  animation-delay: 0.45s;\n}\n\n.realesy-cube {\n  width: 55px;\n  height: 55px;\n  position: relative;\n  transform-style: preserve-3d;\n  animation: realesy-loader-cube 2.6s ease-in-out infinite;\n  perspective: 300px;\n}\n\n.realesy-cube i {\n  position: absolute;\n  display: block;\n  width: 48px;\n  height: 48px;\n  border-radius: 8px;\n  border: 1px solid white;\n}\n\n.realesy-cube i:nth-child(1) {\n  background: linear-gradient(135deg, #ffc064, #ff9200);\n  transform: rotate(45deg) rotateX(60deg) translateZ(22px);\n}\n\n.realesy-cube i:nth-child(2) {\n  background: linear-gradient(135deg, #78a5ff, #2864e8);\n  transform: translateZ(22px);\n}\n\n.realesy-cube i:nth-child(3) {\n  background: #c8dcff;\n  transform: translateX(22px) rotateY(45deg);\n}\n\n.realesy-four-dots {\n  width: 104px;\n  height: 101px;\n  display: block;\n  background: transparent;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .realesy-ring,\n  .realesy-ring-logo,\n  .realesy-wave i,\n  .realesy-cube {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
